/* eslint-disable no-unused-vars */
import api from 'configs/api';
import { IRequestResponse } from 'interfaces/RequestResponse';

const endpointUrl = 'diverse-activity';

export const postAddBoletimDiverse = async params => {
  const url = `${endpointUrl}/add`;
  const { data } = await api.post<IRequestResponse<null>>(url, params);
  return data;
};
